// extracted by mini-css-extract-plugin
export default {"createAndSendDialogText":"RegularOrderDetailsPage_createAndSendDialogText__McMyc"};